

import axios from 'axios'
import routes from '../../../services/api/api'

export default async (id,data) => {
  return new Promise((resolve, reject) => {
    axios({
        url: `${routes.SL_WHOLESALE_DISCOUNT}/${id}`,
        data,
        method: 'put',
    })
        .then(response => {
            resolve(response)
        })
        .catch(err => {
            reject(err)
        })
})
}
